/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import actions from "../../store/auth/actions";
import {
  // Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Typography,
} from "antd";
import Title from "antd/es/typography/Title";
import { EditOutlined } from "@ant-design/icons";
import "./index.css";
import lifeTime from "../../assets/images/lifetime.svg";
import AvailablePoints from "../../assets/images/availablePoint.svg";
import pointsRedeemed from "../../assets/images/programSaving.svg";
import expired from "../../assets/images/Pointexpiry.svg";
// import { isEmpty } from "lodash";
import moment from "moment/moment";
import api from "../../helpers";
// import SimpleReactValidator from "simple-react-validator";
import { useDispatch, useSelector } from "react-redux";
import { myAccountApi } from "../../store/My-Account/actions";
// import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import { MetaTags } from "react-meta-tags";

const Account = ({ rewards }) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [profileValidations, setProfileValidations] = useState(false);

  // const loggedUser = localStorage.getItem("loggedInUser");
  // const verifiedUserDetails = loggedUser ? JSON.parse(loggedUser) : "";
  // const verifiedUserData =
  //   verifiedUserDetails &&
  //   verifiedUserDetails.data &&
  //   verifiedUserDetails.data.token !== undefined
  //     ? jwtDecode(verifiedUserDetails.data.token)
  //     : "";

  useEffect(() => {
    setTimeout(() => {
      dispatch(myAccountApi());
    }, 1500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //reducer
  const { my_account_list = [] } = useSelector((state) => state.MyAccount);

  console.log(my_account_list, "my_account_list");
  const loggedUser = localStorage.getItem("loggedInUser");
  const verifiedUserDetails = loggedUser ? JSON.parse(loggedUser) : "";
  const verifiedUserData =
    verifiedUserDetails &&
    verifiedUserDetails.data &&
    verifiedUserDetails.data.token !== undefined
      ? jwtDecode(verifiedUserDetails.data.token)
      : "";
  console.log(verifiedUserData, "verifiedUserData");
  const userInfoDetails =
    my_account_list &&
    my_account_list.userData &&
    my_account_list.userData !== undefined
      ? my_account_list.userData
      : "";
  const rewardsPoints =
    my_account_list &&
    my_account_list.rewardPoints &&
    my_account_list.rewardPoints !== undefined
      ? my_account_list.rewardPoints
      : "";
  const scrollRef = useRef(null);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  // const [userResponseData, setUserResponseData] = useState("");

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX);
    setScrollLeft(scrollRef.current.scrollLeft);
    scrollRef.current.style.cursor = "grabbing";
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    scrollRef.current.style.cursor = "grab";
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    scrollRef.current.style.cursor = "grab";
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX;
    const walk = (x - startX) * 5; // Adjust the multiplier for smoother scroll
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX;
    const walk = (x - startX) * 1; // Adjust the multiplier for smoother scroll
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  // console.log(userResponseData, "userResponseData");
  // const userDataResponse =
  //   !isEmpty(userResponseData) && userResponseData ? userResponseData.user : "";
  const items = [
    {
      key: "1",
      label: "First Name",
      value:
        userInfoDetails && userInfoDetails.firstName !== undefined
          ? userInfoDetails.firstName
          : verifiedUserData !== undefined &&
            verifiedUserData.firstName !== undefined
          ? verifiedUserData.firstName
          : "-",
    },
    {
      key: "2",
      label: "Last Name",
      value:
        userInfoDetails && userInfoDetails.lastName !== undefined
          ? userInfoDetails.lastName
          : verifiedUserData !== undefined &&
            verifiedUserData.lastName !== undefined
          ? verifiedUserData.lastName
          : "-",
    },
    {
      key: "3",
      label: "Email Address",
      value:
        userInfoDetails && userInfoDetails.email !== undefined
          ? userInfoDetails.email
          : verifiedUserData !== undefined &&
            verifiedUserData.email !== undefined
          ? verifiedUserData.email
          : "-",
    },
    {
      key: "4",
      label: "Date of Birth",
      value:
        userInfoDetails &&
        userInfoDetails.dateOfBirth !== 0 &&
        userInfoDetails.dateOfBirth !== undefined
          ? moment(userInfoDetails.dateOfBirth).format("YYYY-MM-DD")
          : verifiedUserData !== undefined &&
            verifiedUserData.dateOfBirth !== undefined
          ? moment(verifiedUserData.dateOfBirth).format("YYYY-MM-DD")
          : "-",
    },
    {
      key: "5",
      label: "Mobile Number",
      value:
        userInfoDetails && userInfoDetails.mobile !== undefined
          ? userInfoDetails.mobile
          : verifiedUserData !== undefined &&
            verifiedUserData.mobile !== undefined
          ? verifiedUserData.mobile
          : "-",
    },
    {
      key: "6",
      label: "Anniversary",
      value:
        userInfoDetails &&
        userInfoDetails.anniversaryDate !== 0 &&
        userInfoDetails.anniversaryDate !== undefined
          ? userInfoDetails.anniversaryDate
          : "-",
    },
    {
      key: "7",
      label: "Gender",
      value:
        userInfoDetails && userInfoDetails.gender !== undefined
          ? userInfoDetails.gender
          : verifiedUserData !== undefined &&
            verifiedUserData.title !== undefined &&
            (verifiedUserData.title == "Ms" || verifiedUserData.title == "Mrs")
          ? "Female"
          : verifiedUserData !== undefined &&
            verifiedUserData.title !== undefined &&
            (verifiedUserData.title !== "Ms" ||
              verifiedUserData.title !== "Mrs")
          ? "Male"
          : "-",
    },
    {
      key: "8",
      label: "Source",
      value: userInfoDetails ? userInfoDetails.source : "-",
    },
    {
      key: "9",
      label: "Occupation",
      value: userInfoDetails ? userInfoDetails.occupation : "-",
    },
  ];

  const [source, setSource] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [gender, setGender] = useState([]);
  const [dobDate, setDob] = useState("");
  const [anniversaryDate, setAnniversary] = useState("");

  const [userInfoData, setUserInfoData] = React.useState({
    _id: "",
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    Occupation: "",
    secretKey: "",
  });

  console.log(dobDate, anniversaryDate, "date");

  const handleChange = (e) => {
    setUserInfoData({
      ...userInfoData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (userInfoDetails) {
      setUserInfoData({
        _id:
          userInfoDetails !== undefined && userInfoDetails._id !== undefined
            ? userInfoDetails._id
            : verifiedUserData._id,
        firstName:
          userInfoDetails !== undefined &&
          userInfoDetails.firstName !== undefined
            ? userInfoDetails.firstName
            : verifiedUserData.firstName,
        lastName:
          userInfoDetails !== undefined &&
          userInfoDetails.lastName !== undefined
            ? userInfoDetails.lastName
            : verifiedUserData.lastName,
        mobile:
          userInfoDetails !== undefined && userInfoDetails.mobile !== undefined
            ? userInfoDetails.mobile
            : verifiedUserData.mobile,
        email:
          userInfoDetails !== undefined && userInfoDetails.email !== undefined
            ? userInfoDetails.email
            : verifiedUserData.email,
      });
      setOccupation(
        userInfoDetails.occupation !== undefined
          ? {
              value: userInfoDetails.occupation,
              label: userInfoDetails.occupation,
            }
          : []
      );
      setSource(
        userInfoDetails.source !== undefined
          ? {
              value: userInfoDetails.source,
              label: userInfoDetails.source,
            }
          : []
      );
      setGender(
        userInfoDetails !== undefined && userInfoDetails.gender !== undefined
          ? {
              value: userInfoDetails.gender,
              label: userInfoDetails.gender,
            }
          : verifiedUserData !== undefined &&
            verifiedUserData.gender !== undefined
          ? {
              value: verifiedUserData.gender,
              label: verifiedUserData.gender,
            }
          : []
      );
      setDob(
        userInfoDetails.dateOfBirth !== undefined
          ? moment(userInfoDetails.dateOfBirth, "YYYY-MM-DD") ||
              userInfoDetails.dateOfBirth
          : null
      );
      setAnniversary(
        userInfoDetails.anniversaryDate !== undefined
          ? moment(userInfoDetails.anniversaryDate, "YYYY-MM-DD")
          : null
      );
    } else {
      setUserInfoData({
        _id:
          userInfoDetails !== undefined && userInfoDetails._id !== undefined
            ? userInfoDetails._id
            : verifiedUserData._id,
        firstName:
          userInfoDetails !== undefined &&
          userInfoDetails.firstName !== undefined
            ? userInfoDetails.firstName
            : verifiedUserData.firstName,
        lastName:
          userInfoDetails !== undefined &&
          userInfoDetails.lastName !== undefined
            ? userInfoDetails.lastName
            : verifiedUserData.lastName,
        mobile:
          userInfoDetails !== undefined && userInfoDetails.mobile !== undefined
            ? userInfoDetails.mobile
            : verifiedUserData.mobile,
        email:
          userInfoDetails !== undefined && userInfoDetails.email !== undefined
            ? userInfoDetails.email
            : verifiedUserData.email,
      });
      setOccupation(
        userInfoDetails.occupation !== undefined
          ? {
              value: userInfoDetails.occupation,
              label: userInfoDetails.occupation,
            }
          : []
      );
      setSource(
        userInfoDetails.source !== undefined
          ? {
              value: userInfoDetails.source,
              label: userInfoDetails.source,
            }
          : []
      );
      setGender(
        verifiedUserData !== undefined && verifiedUserData.title !== undefined
          ? {
              value:
                verifiedUserData.title == "Ms" ||
                verifiedUserData.title == "Mrs"
                  ? "Female"
                  : "Male",
              label:
                verifiedUserData.title == "Ms" ||
                verifiedUserData.title == "Mrs"
                  ? "Female"
                  : "Male",
            }
          : {
              value: userInfoDetails.gender,
              label: userInfoDetails.gender,
            }
      );
      setDob(
        userInfoDetails.dateOfBirth !== undefined
          ? moment(userInfoDetails.dateOfBirth, "YYYY-MM-DD") ||
              userInfoDetails.dateOfBirth
          : null
      );
      setAnniversary(
        userInfoDetails.anniversaryDate !== undefined
          ? moment(userInfoDetails.anniversaryDate, "YYYY-MM-DD")
          : null
      );
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal]);

  const updateProfile = () => {
    if (
      userInfoData.firstName !== "" &&
      // userInfoData.lastName !== "" &&
      userInfoData.mobile !== "" &&
      gender.value !== ""
    ) {
      setProfileValidations(true);

      const updateData = {
        // user_id: userInfoData._id,
        firstName: userInfoData.firstName,
        lastName: userInfoData.lastName,
        email: userInfoData.email,
        mobile: userInfoData.mobile,
        gender: gender && gender.value ? gender.value : "",
        source: source && source.value ? source.value : "",
        dateOfBirth: dobDate ? dobDate.format("YYYY-MM-DD") : "",
        anniversaryDate: anniversaryDate
          ? anniversaryDate.format("YYYY-MM-DD")
          : "",
        occupation: occupation && occupation.value ? occupation.value : "",
      };
      const profileObj = Object.keys(updateData).forEach(
        (k) =>
          (updateData[k] == "" || updateData[k] == undefined) &&
          delete updateData[k]
      );
      console.log(profileObj, "profileObj");
      api
        .put("/user/update-profile", updateData)
        .then((response) => {
          // setUserResponseData(response.data.data);
          toast.success("Profile updated successfully");
          // localStorage.setItem("loggedInUser", response.data);
          dispatch(myAccountApi());
          setTimeout(() => {
            setModal(false);
          }, 1000);
          return response.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(errorMsg || "There is an issue while update the profile");
          return Promise.reject(error);
        });

      setModal(false);
      // setStart(false)
      console.log(updateData, "updateData");
    } else {
      setProfileValidations(true);
      setModal(true);
    }
  };

  useEffect(() => {
    if (modal) {
      setTimeout(() => {
        document.body.style.paddingRight = "0px";
      }, 50);
    } else {
      document.body.style.paddingRight = "";
    }
  }, [modal]);

  useEffect(() => {
    if (rewardsPoints && rewardsPoints !== undefined) {
      rewards(rewardsPoints);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [my_account_list]);

  console.log(rewardsPoints, "rewardsPoints");

  return (
    <React.Fragment>
      <MetaTags>
        <title>My Account | PMT</title>
      </MetaTags>
      <div className="account-cards border border-1 rounded-sm p-8">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h1
              style={{
                marginTop: "-1px",
                fontWeight: "bold",
                fontSize: "18px",
              }}
              className="uppercase input-login-label"
            >
              Profile Details
            </h1>
          </div>

          <div>
            <div
              style={{
                marginTop: "-3px",
                fontFamily: "Poppins",
              }}
              onClick={() => {
                setModal(!modal);
              }}
              className="flex bg-[#eb3e43] text-[white] cursor-pointer rounded-md hover:bg-[#e5272c] focus:bg-[#e5272c] pl-4 pr-4 pt-1 pb-1"
            >
              <EditOutlined className="mr-1" /> Edit Profile
            </div>
          </div>
        </div>

        <div style={{ marginTop: "15px" }}>
          <Row gutter={[16, 16]} className="my-account-points-card">
            {items.map((item) => (
              <React.Fragment key={item.key}>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Typography
                    style={{
                      color: "GrayText",
                      fontSize: "14px",
                      fontFamily: "Poppins",
                    }}
                  >
                    {item.label}:
                  </Typography>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Typography
                    style={{
                      fontWeight: "bold",
                      fontFamily: "Poppins",
                    }}
                  >
                    {item.value}
                  </Typography>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
        {/* 
        <div style={{ marginTop: "15px" }}>
          <Row gutter={[16, 16]}>
            {account_List && account_List.map((item) => (
              <React.Fragment key={item.key}>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Typography style={{ color: "GrayText", fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
                    {!isEmpty(item.label) ? item.label :""}:
                  </Typography>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Typography style={{ fontWeight: "bold" }}>
                  {!isEmpty(item.value) ? item.value :""}:
                  </Typography>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div> */}

        <Divider />

        <Typography
          style={{
            fontFamily: "Poppins",
            fontSize: "16PX",
          }}
        >
          Points Summary
        </Typography>

        <div style={{ backgroundColor: "#F5F5F5", marginTop: "10px" }}>
          <div
            className="profile-stats-container"
            ref={scrollRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
          >
            <ul className="profile-stats-ul">
              <li
                className="profile-stats-li"
                style={{
                  marginLeft: "20px",
                }}
              >
                <Card
                  style={{
                    width: "180px",
                    height: "80px",
                    margin: "15px 15px",
                  }}
                >
                  <Row>
                    <Col span={6}>
                      <Image
                        preview={false}
                        src={lifeTime}
                        alt="Lifetime Points"
                        style={{ marginTop: "5px" }}
                      />
                    </Col>
                    <Col span={18} className="input-login-label">
                      <Typography.Text
                        style={{
                          marginLeft: "5px",
                          fontFamily: "Poppins",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Lifetime Points
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        style={{
                          marginLeft: "35px",
                          fontWeight: "bold",
                          fontFamily: "Poppins",
                          fontSize: "16px",
                        }}
                      >
                        {rewardsPoints !== undefined && rewardsPoints !== ""
                          ? rewardsPoints.lifeTimePoints
                          : 0}
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </li>
              <li className="profile-stats-li">
                <Card
                  style={{
                    width: "180px",
                    height: "80px",
                    margin: "15px 15px",
                  }}
                >
                  <Row>
                    <Col span={6}>
                      <Image
                        preview={false}
                        src={AvailablePoints}
                        alt="Available Points"
                        style={{
                          marginTop: "5px",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      />
                    </Col>
                    <Col span={18}>
                      <Typography.Text
                        style={{
                          marginLeft: "4px",
                          fontFamily: "Poppins",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Available Points
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        style={{
                          marginLeft: "35px",
                          fontWeight: "bold",
                          fontFamily: "Poppins",
                          fontSize: "16px",
                        }}
                      >
                        {rewardsPoints !== undefined && rewardsPoints !== ""
                          ? rewardsPoints.availableRewardPoints
                          : 0}
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </li>
              <li className="profile-stats-li">
                <Card
                  style={{
                    width: "200px",
                    height: "80px",
                    margin: "15px 15px",
                  }}
                >
                  <Row>
                    <Col span={6}>
                      <Image
                        preview={false}
                        src={pointsRedeemed}
                        alt="Points Redeemed"
                        style={{ marginTop: "5px" }}
                      />
                    </Col>
                    <Col span={18}>
                      <Typography.Text
                        style={{
                          marginLeft: "5px",
                          fontFamily: "Poppins",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Points Redeemed
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        style={{
                          marginLeft: "35px",
                          fontWeight: "bold",
                          fontFamily: "Poppins",
                          fontSize: "16px",
                        }}
                      >
                        {rewardsPoints !== undefined && rewardsPoints !== ""
                          ? rewardsPoints.redeemedRewardPoints
                          : "N/A"}
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </li>
              <li className="profile-stats-li">
                <Card
                  style={{
                    width: "200px",
                    height: "80px",
                    margin: "15px 15px",
                  }}
                >
                  <Row>
                    <Col span={6}>
                      <Image
                        preview={false}
                        src={expired}
                        alt="Points Near Expire"
                        style={{ marginTop: "5px" }}
                      />
                    </Col>
                    <Col span={18}>
                      <Typography.Text
                        className="text-nowrap"
                        style={{
                          marginLeft: "2px",
                          fontFamily: "Poppins",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Points Near Expire
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        style={{
                          marginLeft: "35px",
                          fontWeight: "bold",
                          fontFamily: "Poppins",
                          fontSize: "16px",
                        }}
                      >
                        {rewardsPoints !== undefined && rewardsPoints !== ""
                          ? rewardsPoints.nearExpiringRewardPoints
                          : "N/A"}
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Edit profile modal */}
      <Modal
        open={modal}
        onCancel={() => {
          setModal(!modal);
        }}
        centered
        footer={[
          <div className="flex justify-end">
            <div
              style={{
                borderRadius: "4px",
              }}
              onClick={() => setModal(false)}
              className="mr-3 hover:bg-[lightgray] cursor-pointer pl-4 pr-4 pt-1 pb-1 package-fonts border border-1 text-center text-[14px] bg-[white]"
            >
              <h1 className="">Cancel</h1>
            </div>
            <div
              style={{
                borderRadius: "4px",
              }}
              onClick={() => updateProfile()}
              className="cursor-pointer hover:bg-[red] pl-4 pr-4 pt-1 pb-1 package-fonts text-center text-[14px] bg-[#eb3e43] text-[white]"
            >
              <h1 className="">Update</h1>
            </div>
          </div>,
        ]}
      >
        <Title
          style={{
            marginTop: "-5px",
            fontWeight: "bold",
            fontSize: "18px",
            fontFamily: "Poppins",
          }}
          level={5}
        >
          Profile Details
        </Title>
        <Divider className="mt-[2px] w-[112%] ml-[-24px]" />
        <Form className="custom-form">
          <Row>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="pr-4"
            >
              <Typography className="text-[13px] input-login-label font-medium mb-1">
                First Name
              </Typography>
              <Input
                placeholder="Enter First Name"
                name="firstName"
                value={userInfoData.firstName}
                onChange={(e) => handleChange(e)}
                className="h-[35px]"
              />
              <p className="text-start text-[red] mt-1 text[11px]">
                {profileValidations === true && userInfoData.firstName === ""
                  ? "The first name field is required"
                  : ""}
              </p>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="pr-4"
            >
              <Typography className="text-[13px] input-login-label font-medium mb-1">
                Last Name
              </Typography>
              <Input
                placeholder=" Enter Last Name"
                name="lastName"
                value={userInfoData.lastName}
                onChange={(e) => handleChange(e)}
                className="h-[35px]"
              />
              {/* <p className="text-start text-[red] mt-1 text[11px]">
                {simpleValidator.current.message(
                  "lastName",
                  userInfoData.lastName,
                  "required"
                )}
              </p> */}
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="pr-4 mt-2"
            >
              <Typography className="text-[13px] input-login-label font-medium mb-1">
                Email
              </Typography>
              <Input
                placeholder="Enter Email"
                name="email"
                value={userInfoData.email}
                onChange={(e) => handleChange(e)}
                className="h-[35px]"
              />
              {/* <p className="text-start text-[red] mt-1 text[11px]">
                {simpleValidator.current.message(
                  "email",
                  userInfoData.email,
                  "required"
                )}
              </p> */}
              <p className="text-start text-[red] mt-1 text[11px]">
                {profileValidations === true && userInfoData.email === ""
                  ? "The email field is required"
                  : ""}
              </p>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="pr-4 mt-2"
            >
              <Typography className="text-[13px] input-login-label font-medium mb-1">
                Date of Birth
              </Typography>
              <DatePicker
                placeholder=" DOB"
                value={dobDate}
                onChange={(date) => {
                  setDob(date);
                }}
                format="YYYY-MM-DD"
                style={{
                  height: "35px",
                  width: "100%",
                }}
              />
              {/* <p className="text-start text-[red] mt-1 text[11px]">
                {simpleValidator.current.message(
                  "date of birth",
                  dobDate,
                  "required"
                )}
              </p> */}
            </Col>

            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="pr-4 mt-2"
            >
              <Typography className="text-[13px] input-login-label font-medium mb-1">
                Mobile
              </Typography>
              <Input
                placeholder="Enter Mobile"
                name="mobile"
                value={userInfoData.mobile}
                onChange={(e) => handleChange(e)}
                disabled
                className="h-[35px]"
              />
              <p className="text-start text-[red] mt-1 text[11px]">
                {profileValidations === true && userInfoData.mobile === ""
                  ? "The mobile field is required"
                  : ""}
              </p>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="pr-4 mt-2"
            >
              <Typography className="text-[13px] input-login-label font-medium mb-1">
                Anniversary
              </Typography>
              <DatePicker
                placeholder="Anniversary"
                value={anniversaryDate}
                onChange={(date) => {
                  setAnniversary(date);
                }}
                format="YYYY-MM-DD"
                placement="Top-bottom"
                style={{
                  width: "100%",
                  height: "35px",
                }}
              />
              {/* <p className="text-start text-[red] mt-1 text[11px]">
                {simpleValidator.current.message(
                  "Anniversary",
                  anniversaryDate,
                  "required"
                )}
              </p> */}
            </Col>

            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="pr-4 mt-2"
            >
              <Typography className="text-[13px] input-login-label font-medium mb-1">
                Gender
              </Typography>
              <Select
                allowClear
                value={gender}
                onChange={(e, options) =>
                  setGender({
                    label: options.label,
                    value: e,
                  })
                }
                style={{
                  width: "100%",
                  height: "35px",
                }}
                placeholder={"Select Gender"}
                options={[
                  {
                    value: "Male",
                    label: "Male",
                  },
                  {
                    value: "Female",
                    label: "Female",
                  },
                  {
                    value: "Others",
                    label: "Others",
                  },
                ]}
              />
              {/* <p className="text-start text-[red] mt-1 text[11px]">
                {simpleValidator.current.message("Gender", gender, "required")}
              </p> */}
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="pr-4 mt-2"
            >
              <Typography className="text-[13px] input-login-label font-medium mb-1">
                Source
              </Typography>
              <Select
                allowClear
                value={source}
                onChange={(e, options) =>
                  setSource({
                    label: options.label,
                    value: e,
                  })
                }
                style={{
                  width: "100%",
                  height: "35px",
                }}
                placeholder={"Select Source"}
                options={[
                  { value: "Facebook", label: "Facebook" },
                  { value: "Instagram", label: "Instagram" },
                  { value: "Friends", label: "Friends" },
                  { value: "Relatives", label: "Relatives" },
                ]}
              />
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="pr-4 mt-2"
            >
              <Typography className="text-[13px] input-login-label font-medium mb-1">
                Occupation
              </Typography>
              <Select
                allowClear
                value={occupation}
                onChange={(e, options) =>
                  setOccupation({
                    label: options.label,
                    value: e,
                  })
                }
                style={{
                  width: "100%",
                  height: "35px",
                }}
                placeholder={"Select Occupation"}
                options={[
                  { value: "Student", label: "Student" },
                  { value: "Laborer", label: "Laborer" },
                  { value: "Factory Work", label: "Factory Work" },
                  { value: "Owner-Operator", label: "Owner-Operator" },
                  { value: "Self Employed", label: "Self Employed" },
                  { value: "Employed", label: "Employed" },
                  { value: "Homemaker", label: "Homemaker" },
                  { value: "Unemployed", label: "Unemployed" },
                  { value: "Retired", label: "Retired" },
                ]}
              />
            </Col>
          </Row>
          <Divider className="w-[111%] ml-[-24px]" />
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Account;
